"use client";

type SegmentedItem = {
    id: string;
    label: string;
    disabled?: boolean;
};

type Props = {
    items: SegmentedItem[];
    value: string;
    onChange: (id: string) => void;
};

/**
 * N 択のセグメント切替（ビューUIの表現切替＝一覧/表/ボード/グラフ 等）。
 * 2 択固定の ToggleButton とは別物（選択肢数が可変・無効化可）。状態なし・props 経由のみのプリミティブ。
 */
export function SegmentedControl({ items, value, onChange }: Props) {
    return (
        <div className="inline-flex overflow-hidden rounded border border-border-subtle text-xs">
            {items.map((item) => (
                <button
                    key={item.id}
                    type="button"
                    disabled={item.disabled}
                    onClick={() => onChange(item.id)}
                    className={`px-2 py-0.5 transition-colors ${
                        value === item.id
                            ? "bg-interactive-active text-white"
                            : "text-text-secondary hover:bg-sidebar-bg disabled:opacity-40 disabled:hover:bg-transparent"
                    }`}
                >
                    {item.label}
                </button>
            ))}
        </div>
    );
}
